<div class="block-wrapper" [class.selected]="isSelected" [class.mobile]="isMobileDisplay">

    <div class="content-wrapper">
        <div class="header">
            <div fxLayout="row" fxLayoutAlign="space-between center" >
                <div class="title">
                    {{ 'bloc' | translate }}&nbsp;{{ blocNumber }}
                </div>
                <div class="value">
                    {{ data.data.nbRepeat }} x
                </div>
                <ng-container *ngIf="isEditable">
                    <div class="actions">
                        <button mat-icon-button *ngIf="!itsTheFirst"
                                [matTooltip]="'Move_up' | translate"
                                (click)="moveup(data, false)">
                            <mat-icon>arrow_upward</mat-icon>
                        </button>
                        <button mat-icon-button *ngIf="!itsTheLast"
                                [matTooltip]="'Move_down' | translate"
                                (click)="movedown(data, false)">
                            <mat-icon>arrow_downward</mat-icon>
                        </button>

                        <button mat-icon-button [matMenuTriggerFor]="menu" >
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item
                                    [matTooltip]="'Duplicate' | translate"
                                    (click)="duplicateSelf()">
                                <mat-icon>filter_none</mat-icon>
                                <span>{{ 'Duplicate' | translate}}</span>
                            </button>
                            <button mat-menu-item
                                    [matTooltip]="'Delete' | translate"
                                    (click)="delete(data)">
                                <mat-icon>delete_outline</mat-icon>
                                <span>{{ 'Delete' | translate}}</span>
                            </button>
                        </mat-menu>
                    </div>
                </ng-container>
            </div>
        </div>

        <ng-container *ngIf="isEditable">
            <div class="cdk-drop-list bloc-content"
                 cdkDropList
                 [cdkDropListData]="data.innerElements"
                 (cdkDropListDropped)="onDropEvent($event)"
                 [cdkDropListEnterPredicate]="dropPredicate"
                 [cdkDropListConnectedTo]="exerciceDropList"
            >
              <div class="no-item-drop-list" *ngIf="data.innerElements.length === 0"></div>

                <div class="cdk-drop-item" cdkDrag *ngFor="let item of data.innerElements; let itemIndex = index" [cdkDragData]="item"
                >

                    <session-comment #sessionComment *ngIf="item.type === 'COMMENT'"
                                     [data]="item"
                                     [parentIndex]="parentIndex"
                                     [itsTheFirst]="(itemIndex === 0)"
                                     [itsTheLast]="(itemIndex === (data.innerElements.length - 1))"
                                     [isEditable]="isEditable"
                                     (click)="editorService.blockClickedEvent(item, sessionComment, $event);"
                                     (onDelete)="delete($event)"
                                     (onDuplicate)="duplicate($event)"
                                     (onMoveUp)="moveup($event)"
                                     (onMoveDown)="movedown($event)"
                                     (onChanged)="onChanged.emit()">
                    </session-comment>

                    <session-rest #sessionRest *ngIf="item.type === 'REST'"
                                  [data]="item"
                                  [parentIndex]="parentIndex"
                                  [itsTheFirst]="(itemIndex === 0)"
                                  [itsTheLast]="(itemIndex === (data.innerElements.length - 1))"
                                  [isEditable]="isEditable"
                                  (click)="editorService.blockClickedEvent(item, sessionRest, $event)"
                                  (onTimeBasedInfoUpdated)="onTimeBasedInfoUpdated_child($event)"
                                  (onDelete)="delete($event)"
                                  (onDuplicate)="duplicate($event)"
                                  (onMoveUp)="moveup($event)"
                                  (onMoveDown)="movedown($event)"
                                  (onChanged)="onChanged.emit()">
                    </session-rest>

                    <session-exercice-duration #sessionExerciseDuration *ngIf="item.type === 'EXERCICE' && item.data.exercice.exercice.exerciceType === EXERCICE_TYPE_DURATION"
                                               [data]="item"
                                               [parentIndex]="parentIndex"
                                               [itsTheFirst]="(itemIndex === 0)"
                                               [itsTheLast]="(itemIndex === (data.innerElements.length - 1))"
                                               [isEditable]="isEditable"
                                               [organization]="organization"
                                               [isMobileDisplay]="isMobileDisplay"
                                               (click)="editorService.blockClickedEvent(item, sessionExerciseDuration, $event)"
                                               (onTimeBasedInfoUpdated)="onTimeBasedInfoUpdated_child($event)"
                                               (onDelete)="delete($event)"
                                               (onPersonalizedExerciceClicked)="personalize($event)"
                                               (onDuplicate)="duplicate($event)"
                                               (onMoveUp)="moveup($event)"
                                               (onMoveDown)="movedown($event)"
                                               (onDuplicateAsModel)="duplicateExerciceAsModel($event)"
                                               (onChanged)="onChanged.emit()"
                                               (onValuesAreGood)="onValuesAreGood.emit()"
                                               (onValuesAreNotGood)="onValuesAreNotGood.emit()">

                    </session-exercice-duration>

                    <session-exercice-repeat #sessionExerciseRepeat *ngIf="item.type === 'EXERCICE' && item.data.exercice.exercice.exerciceType === EXERCICE_TYPE_REPEAT"
                                             [data]="item"
                                             [parentIndex]="parentIndex"
                                             [itsTheFirst]="(itemIndex === 0)"
                                             [itsTheLast]="(itemIndex === (data.innerElements.length - 1))"
                                             [sessionId]=""
                                             [isEditable]="isEditable"
                                             [organization]="organization"
                                             [isMobileDisplay]="isMobileDisplay"
                                             (click)="editorService.blockClickedEvent(item, sessionExerciseRepeat, $event)"
                                             (onTimeBasedInfoUpdated)="onTimeBasedInfoUpdated_child($event)"
                                             (onDelete)="delete($event)"
                                             (onPersonalizedExerciceClicked)="personalize($event)"
                                             (onDuplicate)="duplicate($event)"
                                             (onMoveUp)="moveup($event)"
                                             (onMoveDown)="movedown($event)"
                                             (onDuplicateAsModel)="duplicateExerciceAsModel($event)"
                                             (onChanged)="onChanged.emit()"
                                             (onValuesAreGood)="onValuesAreGood.emit()"
                                             (onValuesAreNotGood)="onValuesAreNotGood.emit()">
                    </session-exercice-repeat>

                </div>

            </div>
        </ng-container>

        <ng-container *ngIf="!isEditable">
            <div class="bloc-content">
                <div *ngFor="let item of data.innerElements; index as i"
                     class="cdk-drop-item not-draggable">
                    <session-comment *ngIf="item.type === 'COMMENT'"
                                     [data]="item"
                                     [isEditable]="isEditable">
                    </session-comment>
                    <session-rest *ngIf="item.type === 'REST'"
                                  [data]="item"
                                  [isEditable]="isEditable">
                    </session-rest>
                    <session-exercice-duration *ngIf="item.type === 'EXERCICE' && item.data.exercice.exercice.exerciceType === EXERCICE_TYPE_DURATION"
                                               [data]="item"
                                               [organization]="organization"
                                               [isEditable]="isEditable"
                                               [isMobileDisplay]="isMobileDisplay"
                                               [stopwatchSelected]="selectedStopwatchExerciseIndex === i && stopwatchSelected"
                                               (openStopwatch)="openStopwatch.emit([i, $event])"
                    >
                    </session-exercice-duration>
                    <session-exercice-repeat *ngIf="item.type === 'EXERCICE' && item.data.exercice.exercice.exerciceType === EXERCICE_TYPE_REPEAT"
                                             [data]="item"
                                             [sessionId]="data.data.sessionId"
                                             [organization]="organization"
                                             [isEditable]="isEditable"
                                             [isMobileDisplay]="isMobileDisplay"
                    >
                    </session-exercice-repeat>
                </div>
            </div>
        </ng-container>

        <div class="footer">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div class="title">
                    {{'EndOfBloc' | translate }}&nbsp;{{ blocNumber }}
                </div>
                <div class="value">
                    {{ data.data.nbRepeat }} x
                </div>
            </div>

            <!--<div *ngIf="isEditable"
                 class="form">
                <mat-form-field color="primary">
                    <input matInput
                           [(ngModel)]="data.data.nbRepeat"
                           type="number"
                           min="1"
                           max="10"
                           [placeholder]="'nbRepeatBlocPlaceholder' | translate"
                           (ngModelChange)="onNbRepeatChange($event)"
                           autocomplete="off">
                </mat-form-field>

            </div>-->

        </div>
    </div>
    <div class="drag-handle" ngxDragHandle *ngIf="isEditable">
        <mat-icon>drag_indicator</mat-icon>
    </div>
</div>
